import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import {
  ApolloProvider as RawApolloProvider,
  ApolloClient,
  InMemoryCache
} from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import url from './client/url'
import FirebaseContext from '../../../contexts/FirebaseContext'
import AuthContext from '../../../contexts/AuthContext'
import { createUploadLink } from 'apollo-upload-client'

const propTypes = {
  children: PropTypes.any
}

const defaultHeaders = {
  'Apollo-Require-Preflight': 'true'
}

// const httpLink = new HttpLink({ uri: `${url}/graphql` })
const httpLink = createUploadLink({
  uri: `${url}/graphql`,
  headers: defaultHeaders
})

// ✅ Crear UNA SOLA instancia de cache que persista
const cache = new InMemoryCache({
  typePolicies: {
    // Configurar políticas de cache para mejorar la normalización
    Service: {
      fields: {
        topics: {
          // Asegurar que topics se cachean correctamente
          merge: false // Reemplazar array completo en lugar de hacer merge
        }
      }
    }
  }
})

function ApolloProvider({ children }) {
  const firebase = useContext(FirebaseContext)
  // ✅ Usar el mismo cache en ambas instancias
  const [client, setClient] = useState(new ApolloClient({ cache, link: httpLink }))
  const [firebaseAuthed, setFirebaseAuth] = useState(false)

  useEffect(() => {
    if (firebase) {
      firebase.auth().onAuthStateChanged(async (user) => {
        if (user) {
          const asyncAuthLink = setContext(
            (_, { headers }) =>
              new Promise((resolve, reject) => {
                // do some async lookup here
                user.getIdToken().then((token) => {
                  resolve({
                    headers: {
                      ...defaultHeaders,
                      ...headers,
                      authorization: `Bearer ${token}`
                    }
                  })
                }).catch(reject)
              })
          )
          setClient(
            new ApolloClient({
              cache, // ✅ Reutilizar el mismo cache
              link: asyncAuthLink.concat(httpLink)
            })
          )
          setFirebaseAuth(true)
        } else {
          setFirebaseAuth(false)
        }
      })
    }
  }, [firebase])

  return <AuthContext.Provider value={firebaseAuthed}><RawApolloProvider client={client}>{children}</RawApolloProvider></AuthContext.Provider>
}

ApolloProvider.propTypes = propTypes

export default ApolloProvider
